import { ButtonProps, Button } from '@mui/material';
import { styled } from '@mui/material/styles';

export const ButtonStyled = styled(Button)<ButtonProps>(({ theme }) => ({
  '&.MuiButton-root': {
    borderRadius: '25px',
    padding: `${theme.spacing(1)} ${theme.spacing(2)}`,
    '&:active': {
      transform: 'scale(0.98)',
    },
    '&:hover': {
      backgroundColor: 'rgba(0, 0, 30, 0.04)',
    },
  },
  '&.MuiButton-containedPrimary': {
    transition: 'background-color ease 0.4s',
    backgroundColor: theme.palette.primary.main,
    '&:hover': {
      backgroundColor: theme.palette.primary.dark,
    },
    '&.Mui-disabled': {
      color: theme.palette.primary.contrastText,
      opacity: 0.38,
      backgroundColor: theme.palette.primary.main,
    },
  },
  '&.MuiButton-containedSecondary': {
    transition: 'background-color ease 0.4s',
    backgroundColor: theme.palette.secondary.main,
    '&:hover': {
      backgroundColor: theme.palette.secondary.dark,
    },
    '&.Mui-disabled': {
      color: theme.palette.secondary.contrastText,
      opacity: 0.38,
      backgroundColor: theme.palette.secondary.main,
    },
  },
  '&.MuiButton-containedTertiary': {
    transition: 'background-color ease 0.4s',
    backgroundColor: theme.palette.tertiary.main,
    '&:hover': {
      backgroundColor: theme.palette.tertiary.dark,
    },
    '&.Mui-disabled': {
      color: theme.palette.tertiary.contrastText,
      opacity: 0.38,
      backgroundColor: theme.palette.tertiary.main,
    },
  },
  '&.MuiButton-sizeSmall': {
    padding: `${theme.spacing(0.25)} ${theme.spacing(1.5)}`,
  },
  '&.MuiButton-textSizeSmall': {
    padding: `${theme.spacing(0.5)} ${theme.spacing(2)}`,
    minWidth: 'initial',
  },
  '&.MuiButton-sizeMedium': {
    minWidth: '130px',
  },
  '&.MuiButton-textSizeMedium': {
    minWidth: 'inherit',
  },
  '&.MuiButton-sizeLarge': {
    padding: `${theme.spacing(1.4)} ${theme.spacing(4)}`,
    minWidth: '150px',
  },
  '&.MuiButton-textSizeLarge': {
    padding: `${theme.spacing(1.4)} ${theme.spacing(4)}`,
    minWidth: 'inherit',
  },
}));
